import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCampground } from '@fortawesome/free-solid-svg-icons'
import {
  informationCircle, arrowForward,
  helpCircle,  newspaperOutline, cameraOutline, imageOutline, closeOutline,
} from 'ionicons/icons';
import {
  IonGrid, IonRow, IonCol, IonModal, IonSegment, IonSegmentButton,
  IonList, IonItem, IonLabel, IonLoading, withIonLifeCycle, IonAlert,
  IonPage, IonIcon, IonCardContent, IonCard, IonSkeletonText, IonToast,
  IonCardHeader, IonCardSubtitle, IonCardTitle, IonBackButton, IonButton,
  IonButtons, IonContent, IonHeader, IonTitle, IonToolbar, IonSpinner,
} from '@ionic/react';
import ActionButtons from '../components/ActionButtons';
import OperatingHours from '../components/OperatingHours';
import EntranceFees from '../components/EntranceFees';
import Weather from '../components/Weather';
import Contacts from '../components/Contacts';
import Address from '../components/Address';
import SkeletonComponent from '../components/SkeletonComponent';
import AddPhotoModal from '../components/AddPhotoModal';
import PreviewGallery from '../components/PreviewGallery';
import EntrancePasses from '../components/EntrancePasses';
import StarsReview from '../components/StarsReview';
import Direction from '../components/Direction';
import Activities from '../components/Activities';
import { RootState, actions } from '../store';
import './PlaceDetail.css';
import { Token } from '../store/users/types';
import { Plugins, CameraResultType } from '@capacitor/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

const { Camera, PhotoViewer} = Plugins;

type Props = RouteComponentProps<{ id: string, tab: string }> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  goBack: () => void
};

type State = {
  showAlert: boolean;
  messageAlert: string;
  mapUpdated: boolean;
  photo: string;
  showModal: boolean;
  showModalStockPhoto: boolean;
  caption: string;
  segment: string;
  imageUrl: string;
  showSharedPhotosOnly: boolean;
  isMyPhotosLoaded: boolean;
};

class PlaceDetail extends React.Component<Props, State> {
  mapEle: any;
  map?: any;
  defaultState: State = {
    messageAlert: '',
    showAlert: false,
    segment: 'stock-photos',
    showSharedPhotosOnly: true,
    mapUpdated: false,
    imageUrl: '',
    photo: '',
    showModalStockPhoto: false,
    showModal: false,
    isMyPhotosLoaded: false,
    caption: '',
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState
    };
    this.mapEle = React.createRef();
    const { match, loadedCampgrounds, loadedVisitorCenters, parkStats, loadedAlerts } = this.props;
    // const selectedPark = loadedParks[match.params.id];
    const selectedCamps = loadedCampgrounds[match.params.id];
    const selectedCenters = loadedVisitorCenters[match.params.id];
    const selectedAlerts = loadedAlerts[match.params.id];
    const selectedParkStats = parkStats[match.params.id];
    this.props.getParkPhotosByCode(match.params.id);
    if (!selectedParkStats) {
      this.props.getParkStatByCode(match.params.id);
    }
    // if (!selectedPark) {

    // }
    if (!selectedCamps) {
      this.props.getCampgroundsByCode(match.params.id);
    }
    if (!selectedCenters) {
      this.props.getVisitorCentersByCode(match.params.id);
    }
    if (!selectedAlerts) {
      this.props.getAlertsByCode(match.params.id);
    }
    defineCustomElements(window);
  }
  async ionViewDidEnter() {
    const { match, loadedParks } = this.props;
    const selectedPark = loadedParks[match.params.id];
    if (!selectedPark) {
      await this.props.getParkByCode(match.params.id);
    }
  }

  async takePicture() {
    const { isLoggedIn } = this.props;
    if (!isLoggedIn) {
      this.setState({
        ...this.state,
        showAlert: true,
        messageAlert: 'Please login to share a photo.',
      });
      return;
    }
    const image: any = await Camera.getPhoto({
      quality: 20,
      allowEditing: false,
      // height: 450,
      // width: 450,
      saveToGallery: true,
      resultType: CameraResultType.Uri,
    });
    const imageUrl = image.webPath;
    // console.log(imageUrl, image);
    // Can be set to the src of an image now
    this.setState({
      ...this.state,
      photo: imageUrl,
      showModal: true,
    });
  }

  handleUpload = async () => {
    const { addPhoto, tokens, match } = this.props;
    const { photo, caption } = this.state;
    addPhoto(tokens, match.params.id, photo, caption);
    this.toggleModal();
    this.setState({
      caption: '',
    });
    setTimeout(() => {
      this.props.getParkPhotosByCode(match.params.id);
      this.props.getUserParkPhotosByCode(this.props.tokens, this.props.match.params.id);
    }, 3000);
  }

  updateCaption(val: any) {
    this.setState({
      ...this.state,
      caption: val,
    });
  }

  updateSegment = async (e: CustomEvent) => {
    const { value } = e.detail;
    if (value === "my-photos" && !this.state.isMyPhotosLoaded) {
      await this.props.getUserParkPhotosByCode(this.props.tokens, this.props.match.params.id);
      this.setState({
        isMyPhotosLoaded: true,
      });
    }
    this.setState((prevState) => ({
      ...prevState,
      showSharedPhotosOnly: false,
      segment: value,
    }));
  }
  componentWillMount = async () => {
    const {
      isLoggedIn,
      getUserParkInfo,
      tokens,
      match,
      userParks,
    } = this.props;
    await this.props.getParkByCode(match.params.id);
    if (isLoggedIn) {
      const selectedUserParks = userParks[match.params.id];
      if (!selectedUserParks) {
        await getUserParkInfo(tokens, match.params.id);
      }
      return;
    }
    // const thisTokens: Token = await localForage.getItem('tokens');
    // const todayTime = new Date().getTime();
    // if (thisTokens && thisTokens.refresh_token) {
    //   if (!thisTokens.expired_at || thisTokens.expired_at < todayTime) {
    //     await this.props.refreshTokens(thisTokens.refresh_token);
    //   } else {
    //     await this.props.setTokens(thisTokens);
    //   }
    //   // this.props.getUserInfo(tokens);
    //   return;
    // }
  }
  navigateToPhotoDetails = (parkCode: string, photoId: string) => {
    // this.props.history.push(`${this.props.match.url}/photos/${photoId}`);
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/photos/${photoId}`);
  }
  navigateToPhotos = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/photos`);
  }
  navigateToCampDetails = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/campgrounds`);
  }
  navigateToVisitorCenterDetails = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/visitorcenters`);
  }
  navigateToReviews = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/reviews`);
  }
  navigateToQuestions = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/questions`);
  }
  navigateToMyPhotos = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/myphotos`);
  }
  navigateParkAlerts = (parkCode: string) => () => {
    this.props.history.push(`/${this.props.match.params.tab}/places/${parkCode}/alerts`);
  }
  toggleModal() {
    this.setState({
      ...this.state,
      showModal: !this.state.showModal,
    });
  }
  addMarkers(lat: number, long: number) {
    const { match, loadedParks } = this.props;
    const selectedPark = loadedParks[match.params.id];
    let infoWindow = new google.maps.InfoWindow({
      content: `<h5>${selectedPark.name}</h5>`
    });
    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, long),
      map: this.map,
      title: selectedPark.name
    });
    marker.addListener('click', () => {
      infoWindow.open(this.map, marker);
    });
  }
  openImage(url: string) {
    // if (PhotoViewer) {
    //   alert(PhotoViewer);
    //   PhotoViewer.show(url);
    // } else {
    this.setState({
      imageUrl: url,
      showModalStockPhoto: true,
    });
    // }
  }
  closeImage() {
    this.setState({
      showModalStockPhoto: false,
    });
  }
  componentDidMount() {
    try {
      let adsbygoogle;
      // @ts-ignore
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }
  async componentDidUpdate() {
    if (this.state.mapUpdated) {
      return;
    }
    const { match, loadedParks } = this.props;
    const selectedPark = loadedParks[match.params.id];
    if (!selectedPark) {
      return;
    }
    if (!selectedPark.latLong || this.state.mapUpdated) {
      return;
    }

    const coordinates = selectedPark.latLong.split(',');
    const lat = Number(coordinates[0].replace('lat:', ''));
    const lng = Number(coordinates[1].replace('long:', ''));
    this.map = new google.maps.Map(this.mapEle.current, {
      center: { lat, lng },
      zoom: 5
    });
    this.addMarkers(lat, lng);
    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      if (this.mapEle.current) {
          this.mapEle.current.classList.add('show-map');
      }
    });
    this.setState({
      ...this.state,
      mapUpdated: true,
    });
  }
  dismissAlert() {
    this.setState({
      ...this.state,
      showAlert: false,
      messageAlert: '',
    });
  }
  render() {
    const {
      tokens, isLoggedIn, match, loadedParks, campgroundsLoading, parkStatsLoading, photosLoading,
      visitorCentersLoading, getParkByCodeLoading, userParks, parkStats, photoActionLoading, loadedAlerts,
    } = this.props;
    const hasSharedPhotos = this.props.parkPhotos && this.props.parkPhotos.length && this.state.showSharedPhotosOnly;
    const parkCode = match.params.id;
    const parkInfo = parkStats[parkCode] || {};
    const selectedPark = loadedParks[parkCode];
    const hasAlerts = loadedAlerts[parkCode] && !!loadedAlerts[parkCode].length;
    if (!selectedPark && getParkByCodeLoading) {
      return (
        <IonPage>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton defaultHref={`/${match.params.tab}`} />
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonCard>
              <IonSkeletonText animated style={{ width: '320px', height: '320px', margin: 'auto', marginTop: '20px' }} />
              <IonCardHeader>
                <IonSkeletonText animated style={{ width: '60%', height: '30px' }} />
                <IonSkeletonText animated style={{ width: '100%', height: '80px' }} />
              </IonCardHeader>
              <SkeletonComponent title="" />
              <SkeletonComponent title="" />
              <SkeletonComponent title="" />
              <SkeletonComponent title="" />
            </IonCard>
          </IonContent>
        </IonPage>
      );
    }

    if (!selectedPark) {
      return (
        <IonPage>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton defaultHref={`/${match.params.tab}`} />
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonCard>
              Something went wrong. Please try again later.
            </IonCard>
          </IonContent>
        </IonPage>
      );
    }
    const place = selectedPark;
    const minSelectedPark = {
      name: place.name,
      id: place.id,
      latLong: place.latLong,
      parkCode: place.parkCode,
      states: place.states,
      fullName: place.fullName,
    };
    const visitorCenters = this.props.loadedVisitorCenters[parkCode] || [];
    const campgrounds = this.props.loadedCampgrounds[parkCode] || [];
    if (place == null) {
      return null;
    }
    if (!place.name) {
      return null;
    }
    let phone;
    let email;
    if (place.contacts) {
      phone = place.contacts.phoneNumbers;
      email = place.contacts.emailAddresses;
    }
    let address;
    if (place.addresses) {
      address = place.addresses;
    }
    const campCount = campgrounds.length;
    const centerCount = visitorCenters.length;
    return (
      <IonPage>
        <IonAlert
          isOpen={this.state.showAlert}
          onDidDismiss={() => this.dismissAlert()}
          header={'Alert'}
          message={this.state.messageAlert}
          buttons={['OK']}
        />
        <IonLoading
          isOpen={this.props.addRemoveLoading || photoActionLoading}
          message={'Please wait...'}
          duration={3000}
        />
        <AddPhotoModal
          showModal={this.state.showModal}
          toggleModal={this.toggleModal.bind(this)}
          handleUpload={this.handleUpload.bind(this)}
          updateCaption={this.updateCaption.bind(this)}
          caption={this.state.caption}
          photo={this.state.photo}
        />

        <IonModal isOpen={this.state.showModalStockPhoto}>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="end">
                <IonButton onClick={() => this.closeImage()}><IonIcon icon={closeOutline} /></IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonCard>
              <img alt="" style={{ 'border': '1px solid black', 'minHeight': '100px' }} src={this.state.imageUrl} />
            </IonCard>
          </IonContent>
        </IonModal>

        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref={`/${match.params.tab}`} />
            </IonButtons>
            <IonTitle><div dangerouslySetInnerHTML={{__html: place.name}} /></IonTitle>
            <IonButtons slot="end">
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonButton
            hidden={!hasAlerts}
            expand="full"
            onClick={this.navigateParkAlerts(parkCode)}
            fill="solid"
            color="danger">
              View alerts.
        </IonButton>
        <IonContent>
          <IonCard>
            <IonSegment color="dark" value={hasSharedPhotos ? "camera-photos" : this.state.segment} onIonChange={this.updateSegment}>
              <IonSegmentButton value="camera-photos">
                <IonIcon color="primary" icon={cameraOutline} />
                <IonLabel className="badge-count">{}</IonLabel>
                <IonLabel  color="dark">Shared Photos</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="my-photos">
                <IonIcon color="default" icon={cameraOutline} />
                <IonLabel className="badge-count">{}</IonLabel>
                <IonLabel  color="dark">My Photos</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="stock-photos">
                <IonIcon color="secondary" icon={imageOutline} />
                <IonLabel className="badge-count">{}</IonLabel>
                <IonLabel  color="dark">Stock Photos</IonLabel>
              </IonSegmentButton>
            </IonSegment>
            <IonGrid className={hasSharedPhotos ? "camera-photos" : this.state.segment === "camera-photos" ? '' : 'hidden'}>
              <PreviewGallery
                loading={photosLoading}
                photos={this.props.parkPhotos}
                photoDetailFn={this.navigateToPhotoDetails}
                galleryFn={this.navigateToPhotos}
                parkCode={place.parkCode}
                addPhoto={this.takePicture.bind(this)}
                />
            </IonGrid>
            <IonGrid className={this.state.segment === "my-photos" ? '' : 'hidden'}>
              <PreviewGallery
                loading={photosLoading}
                photos={this.props.userParkPhotos}
                photoDetailFn={this.navigateToPhotoDetails}
                galleryFn={this.navigateToMyPhotos}
                parkCode={place.parkCode}
                addPhoto={this.takePicture.bind(this)}
                />
            </IonGrid>
            <IonGrid className={hasSharedPhotos ? "hidden" : this.state.segment === "stock-photos" ? '' : 'hidden'}>
              <IonRow>
                {place.images.map((item: any, index: number) => {
                  const val = `url(${item.url}), url('../../../assets/img/not-found.png')`;
                  return (
                    <IonCol key={index} size-lg="2" size-md="2" size-sm="4" size-xs="4">
                      <div onClick={() => this.openImage(item.url)} className="image-container" style={{"backgroundImage": val, "backgroundSize": "100% 100%", "backgroundRepeat": "no-repeat"}}></div>
                    </IonCol>
                  )
                })}
              </IonRow>
            </IonGrid>
            <IonButton style={{"float": "right"}} onClick={() => this.takePicture()}>
              Add Photos
            </IonButton>
            <br /><br />
            <ActionButtons tokens={tokens} isLoggedIn={isLoggedIn} userParks={userParks} parkCode={parkCode} park={minSelectedPark} />
            <IonList mode="md" inset={false}>
              <IonItem
                disabled={campgroundsLoading || campCount === 0 }
                onClick={this.navigateToCampDetails(place.parkCode)}>
                <FontAwesomeIcon icon={faCampground} />
                <IonLabel className="paddingLeft">
                  Campground(s):
                  <span className={campgroundsLoading ? 'hidden' : ''}>{campCount}</span>
                  <IonSpinner className={campgroundsLoading ? '' : 'hidden'} name="circles" style={{verticalAlign: 'middle'}}  />
                </IonLabel>
                <IonIcon className='arrow-right' icon={arrowForward} />
              </IonItem>
              <IonItem
                disabled={visitorCentersLoading || centerCount === 0 }
                onClick={this.navigateToVisitorCenterDetails(place.parkCode)}>
                <IonIcon color="dark" icon={informationCircle} />
                <IonLabel className="paddingLeft">
                  Visitor Center(s):
                  <span className={visitorCentersLoading ? 'hidden' : ''}>{centerCount}</span>
                  <IonSpinner className={visitorCentersLoading ? '' : 'hidden'} name="circles" style={{verticalAlign: 'middle'}}  />
                </IonLabel>
                <IonIcon className='arrow-right' icon={arrowForward} />
              </IonItem>
              <IonItem
                onClick={this.navigateToReviews(place.parkCode)}>
                <IonIcon color="dark" icon={newspaperOutline} />
                <IonLabel className="paddingLeft">
                  <StarsReview stars={parkInfo.review_average} />
                  <br />
                  Review(s):
                  <span className={parkStatsLoading ? 'hidden' : ''}>{parkInfo.review_count}</span>
                  <IonSpinner className={parkStatsLoading ? '' : 'hidden'} name="circles" style={{verticalAlign: 'middle'}}  />
                </IonLabel>
                <IonIcon className='arrow-right' icon={arrowForward} />
              </IonItem>
              <IonItem
                onClick={this.navigateToQuestions(place.parkCode)}>
                <IonIcon color="dark" icon={helpCircle} />
                <IonLabel className="paddingLeft">
                  Question(s):
                  <span className={parkStatsLoading ? 'hidden' : ''}>{parkInfo.question_count}</span>
                  <IonSpinner className={parkStatsLoading ? '' : 'hidden'} name="circles" style={{verticalAlign: 'middle'}}  />
                </IonLabel>
                <IonIcon className='arrow-right' icon={arrowForward} />
              </IonItem>
            </IonList>
            <IonCardHeader>
              <IonCardTitle><div dangerouslySetInnerHTML={{__html: place.fullName}} /></IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <p>State(s): {place.states}</p>
              <p>{place.description}</p>
            </IonCardContent>
            <Activities data={place.activities} title="Activites" />
            <ins className="adsbygoogle"
              style={{display:"block",textAlign:"center"}}
              data-ad-layout="in-article"
              data-ad-format="fluid"
              data-ad-client="ca-pub-2796376641761374"
              data-ad-slot="4667790285"></ins>
            <OperatingHours hours={place.operatingHours} title="Operating Hours" />
            <EntranceFees fees={place.entranceFees} title="Entrance Fees" />
            <EntrancePasses passes={place.entrancePasses} title="Entrance Passes" />
            <Weather info={place.weatherInfo} title="Weather" />
            <Contacts phones={phone} emails={email} title="Contacts" />
            <IonCardContent>
              <p>For more information:</p>
              <IonCardSubtitle><a href={place.url}>{place.url}</a></IonCardSubtitle>
            </IonCardContent>
            <Address addresses={address} title="Address" />
            <Direction url={place.Url} info={place.directionsInfo} title="Directions" />
            <IonCardContent>
              <div style={{position: 'relative'}}>
                <div ref={this.mapEle} style={{height: '300px', width: '100%'}} id="location-map"></div>
              </div>
            </IonCardContent>
          </IonCard>
        </IonContent>
        <ins className="adsbygoogle"
					style={{display:'block'}}
					data-ad-client="ca-pub-2796376641761374"
					data-ad-slot="1578893839"
					data-ad-format="auto"
					data-full-width-responsive="true"></ins>
      </IonPage>
    );
  }
}

const mapDispatchToProps = {
  getCampgroundsByCode: (parkCode: string) => actions.campgrounds.getCampgrounds(parkCode),
  getVisitorCentersByCode: (parkCode: string) => actions.visitorCenters.getVisitorCenters(parkCode),
  getParkByCode: (parkCode: string) => actions.places.getParkByCode(parkCode),
  getTokens: () => actions.users.getTokens(),
  refreshTokens: (refresh_token: string) => actions.users.refreshTokens(refresh_token),
  setTokens: (tokens: Token) => actions.users.setTokens(tokens),
  getUserParkInfo: (tokens: Token, parkCode: string) => actions.users.getUserParkInfo(tokens, parkCode),
  getParkStatByCode: (parkCode: string) => actions.places.getParkStatByCode(parkCode),
  getParkPhotosByCode: (parkCode: string) => actions.photos.getPhotosByParkCode(parkCode),
  getAlertsByCode: (parkCode: string) => actions.alerts.getAlertsByCode(parkCode),
  getUserParkPhotosByCode: (tokens: Token, parkCode: string) => actions.photos.getUserParkPhotosByCode(tokens, parkCode),
  addPhoto: (tokens: Token, parkCode: string, img: string, caption: string) => actions.photos.addPhoto(tokens, parkCode, img, caption),
};

const mapStateToProps = (state: RootState) => ({
  loading: state.users.loading,
  parkStatsLoading: state.places.parkStatsLoading,
  addRemoveLoading: state.users.addRemoveLoading,
  isLoggedIn: state.users.loggedIn,
  userParks: state.users.userParks,
  loadedParks: state.places.loadedParks,
  getParkByCodeLoading: state.places.getParkByCodeLoading,
  loadedCampgrounds: state.campgrounds.loadedCampgrounds,
  campgroundsLoading: state.campgrounds.loading,
  loadedAlerts: state.alerts.loadedAlerts,
  alertsLoading: state.alerts.loading,
  loadedVisitorCenters: state.visitorCenters.loadedVisitorCenters,
  visitorCentersLoading: state.visitorCenters.loading,
  tokens: state.users.tokens,
  parkStats: state.places.parkStats,
  parkPhotos: state.photos.loadedPhotos.photos,
  userParkPhotos: state.photos.userLoadedPhotos.photos,
  photoActionLoading: state.photos.actionLoading,
  photosLoading: state.photos.photosLoading,
  // places: state.places.places,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withIonLifeCycle(PlaceDetail));
